import { request } from '@/api/_base'

export const getUserinfo = async () => {
  return await request({
    url: `/api/v1/user/info`,
    headers: {
      'X-Authorization': localStorage.getItem('token') || ''
    }
  })
}

export const getUrl = async (id) => {
  return await request({
    url: `/api/v1/pan/url`,
    params: { id },
    headers: {
      'X-Authorization': localStorage.getItem('token') || ''
    }
  })
}

export const logout = async () => {
  return await request({
    url: `/api/v1/logout`,
    headers: {
      'X-Authorization': localStorage.getItem('token') || ''
    }
  })
}

export const getPayPackages = async () => {
  return await request({
    url: `/api/v1/packages`
  })
}

export const loginSignedUser = async (data) => {
  return await request({
    method: 'post',
    url: `/api/v1/login_signed_user`,
    data
  })
}

export const signWeek = async () => {
  return await request({
    url: `/api/v1/sign/week`,
    headers: {
      'X-Authorization': localStorage.getItem('token') || ''
    }
  })
}

export const unblockUser = async (uid) => {
  return await request({
    url: `/api/v1/user/unblock`,
    params: {
      uid
    },
    headers: {
      'X-Authorization': localStorage.getItem('token') || ''
    }
  })
}
